/**
 * cart-order-minimum.js
 * ------------------------------------------------------------
 * Suma TODAS las piezas marcadas con la propiedad de linea
 * Tipo = "Bajo pedido (proveedor)" en el carrito completo (sin
 * importar el color/producto). Al hacer clic en "Finalizar
 * compra": si el total es mayor a 0 pero menor a 20, BLOQUEA la
 * navegacion y muestra un aviso; si es 0 o >=20, deja pasar.
 *
 * IMPORTANTE (bug corregido): para dejar pasar NO se debe usar
 * form.submit() -- ese metodo nativo del DOM ENVIA el formulario a
 * su action normal (que en el carrito es "/cart", no "/checkout"),
 * sin disparar el evento 'submit' ni la logica especial que
 * Shopify usa para el boton de pagar. Eso hacia que la pagina se
 * recargara sobre si misma en vez de avanzar al checkout. La forma
 * correcta de continuar es navegar directo a /checkout.
 * ------------------------------------------------------------
 */
(function () {
  if (window.__cartOrderMinimumInit) return;
  window.__cartOrderMinimumInit = true;

  var MIN_ORDER_QTY = 20;
  var checking = false;

  function getOrderTotal() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var total = 0;
        (cart.items || []).forEach(function (item) {
          var tipo = item.properties && item.properties.Tipo;
          if (tipo === 'Bajo pedido (proveedor)') {
            total += item.quantity;
          }
        });
        return total;
      });
  }

  function showBanner(remaining) {
    var existing = document.getElementById('cart-order-minimum-banner');
    if (existing) existing.remove();
    if (remaining <= 0) return;

    var banner = document.createElement('div');
    banner.id = 'cart-order-minimum-banner';
    banner.setAttribute('role', 'alert');
    banner.style.cssText =
      'margin:1rem 0;padding:1.2rem 1.4rem;border-radius:8px;background:rgba(238,148,65,0.12);' +
      'color:rgb(180,95,10);font-size:1.4rem;';
    banner.textContent =
      'Te faltan ' +
      remaining +
      ' pieza(s) "Sobre pedido" para completar el m\u00ednimo de ' +
      MIN_ORDER_QTY +
      ' piezas requeridas por nuestro proveedor. Puedes completarlas con cualquier combinaci\u00f3n de colores y tallas.';

    var footer = document.getElementById('main-cart-footer');
    if (footer) {
      footer.insertBefore(banner, footer.firstChild);
    }
  }

  function checkAndRenderBanner() {
    getOrderTotal().then(function (total) {
      var remaining = total > 0 && total < MIN_ORDER_QTY ? MIN_ORDER_QTY - total : 0;
      showBanner(remaining);
    });
  }

  // Bloqueo real del boton de checkout hasta cumplir el minimo
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('#checkout, button[name="checkout"]');
      if (!button || checking) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      checking = true;
      var wasDisabled = button.disabled;
      button.disabled = true;

      getOrderTotal().then(function (total) {
        checking = false;
        button.disabled = wasDisabled;

        if (total > 0 && total < MIN_ORDER_QTY) {
          showBanner(MIN_ORDER_QTY - total);
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          // Se cumple el minimo (o no hay piezas sobre pedido): continuar
          // directo al checkout real de Shopify.
          window.location.href = '/checkout';
        }
      });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', checkAndRenderBanner);
  if (document.readyState !== 'loading') checkAndRenderBanner();
})();
